import comp from "./CreateOrEditAssignment";
export default comp;
